<template>
  <v-row>
    <v-col md="3">
      <v-card>
        <v-card-text>
          <h3>Afiliado:</h3>
          <autocompletar v-if="!buscado" v-model="buscado"></autocompletar>
          <span v-if="buscado">
            {{ buscado.apellido_y_nombre }}
            <v-btn icon color="red">
              <v-icon @click="buscado = undefined">
                mdi-delete
              </v-icon>
            </v-btn>
          </span>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col md="3">
      <v-card>
        <v-card-text>
          <h3>Prestador:</h3>
          <busquedaefector
            v-if="!efector"
            auditoria
            v-model="efector"
          ></busquedaefector>
          <span v-if="efector">
            {{ efector.nombreefector }} ({{ efector.RAZON_SOCI }})
            <v-btn icon>
              <v-icon color="red" @click="efector = undefined">
                mdi-delete
              </v-icon>
            </v-btn>
          </span>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col md="2">
      <v-card>
        <v-card-text>
          <h3>Fecha</h3>
          <v-text-field
            dense
            outlined
            type="date"
            label=""
            v-model="fecha"
            hide-details
            clearable
          ></v-text-field>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col md="2">
      <v-card>
        <v-card-text>
          <h3># solicitud</h3>
          <v-text-field
            dense
            outlined
            label=""
            v-model.number="filtroid_solic"
            hide-details
            clearable
            @keydown.enter.prevent="traerPorFiltros()"
          ></v-text-field>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col md="1">
      <v-row>
        <v-col md="12">
          <v-btn :disabled="!mostrarBoton" @click="traerPorFiltros()">
            <v-icon>
              mdi-magnify
            </v-icon>
            Buscar
          </v-btn>
        </v-col>
        <v-col md="12">
          <v-btn
            :disabled="busqueda == 'ultimas'"
            color="primary"
            @click="traerlistaultimas()"
          >
            <v-icon>
              mdi-magnify
            </v-icon>
            Ultimas
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col md="3">
      <v-card>
        <v-card-text>
          <h3>Convenio</h3>
          <v-autocomplete
            v-model="convenio"
            :items="listaConvenios"
            item-value="id_convenio"
            item-text="descripcion_convenio"
            hide-details
            clearable
            flat
            label=""
            placeholder="Convenio"
            outlined
            dense
            persistent-hint
            return-object
          />
        </v-card-text>
      </v-card>
    </v-col>
    <v-col md="2">
      <v-card>
        <v-card-text>
          <h3>Fecha</h3>
          <v-text-field
            dense
            outlined
            type="date"
            label=""
            v-model="fechaconvenio"
            hide-details
            clearable
          ></v-text-field>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col md="1">
      <v-btn :disabled="!mostrarBotonConvenios" @click="traerPorFiltrosConvenios()">
        <v-icon>
          mdi-magnify
        </v-icon>
        Buscar
      </v-btn>
    </v-col>

    <v-col md="12"> Cant: {{ lista.length }} </v-col>
    <v-col md="12">
      <lista v-if="!selected" :items="lista" tomar v-model="selected"></lista>
    </v-col>
    <v-col md="12" v-if="selected">
      <Modificar
        :auditoria="permisoAuditoria"
        :readonly="
          !permisoAuditoria && selected.estado != 1 && selected.estado != 4
        "
        :idsolic="selected.id_solic"
        :soloderiva="!permisoAuditoria"
        @guardado="guardado()"
      ></Modificar>
    </v-col>
  </v-row>
</template>

<script>
import Lista from '@/components/Practica/Lista'
import autocompletar from '@/components/Beneficiarios/AutoNombreDNINroAfi'
import Modificar from '@/components/Practica/Modificar'
import busquedaefector from '@/components/Efectores/Autocomplete'
import busquedaefectorProvincia from '@/components/Efectores/PorProvincia'
import API from '@/lib/API'
import { mapGetters, mapState } from 'vuex'
export default {
  components: {
    autocompletar,
    busquedaefector,
    busquedaefectorProvincia,
    Lista,
    Modificar,
  },
  data() {
    return {
      busqueda: 'ultimas',
      selected: undefined,
      buscado: undefined,
      lista: [],
      efector: 0,
      fecha: '',
      fechaconvenio: '',
      filtroid_solic: 0,
      estado: 0,
      convenio: {
        id_convenio: -1,
        descripcion_convenio: '',
      },
    }
  },
  computed: {
    ...mapState('beneficiarios', ['Nuevo']),
    ...mapGetters('comun', ['permisoAuditoria']),
    ...mapState('conveniosprestacionales', { convenios: 'Lista' }),
    listaConvenios() {
      let ret = []
      ret.push({
        id_convenio: -1,
        descripcion_convenio: '-- Seleccione --',
      })
      ret = ret.concat(this.convenios)
      return ret
    },
    id_afiliado() {
      let ret = 0
      if (this.buscado) {
        ret = this.buscado.id_afiliado
      }
      return ret
    },
    id_efector() {
      let ret = 0
      if (this.efector) {
        ret = this.efector.Id
      }
      return ret
    },
    strFecha() {
      let ret = 'x'
      if (this.fecha) {
        ret = this.fecha
      }
      return ret
    },
    id_solic() {
      let ret = 0
      if (Number.isInteger(this.filtroid_solic)) {
        ret = this.filtroid_solic
      }
      return ret
    },

    mostrarBoton() {
      let ret = false
      if (
        (this.buscado && this.efector) ||
        (this.buscado && this.fecha) ||
        (this.efector && this.fecha) ||
        this.id_solic
      ) {
        ret = true
      }
      return ret
    },
    mostrarBotonConvenios() {
      let ret = false
      if (this.convenio.id_convenio > -1 && this.fechaconvenio) {
        ret = true
      }
      return ret
    },
  },
  methods: {
    async traerlistaultimas() {
      this.busqueda = 'ultimas'
      this.lista = await API.Autorizaciones.traerUltimas()
    },
    async traerPorFiltros() {
      this.busqueda = 'filtros'
      this.lista = await API.Autorizaciones.traerPorFiltros(
        this.id_afiliado,
        this.id_efector,
        this.strFecha,
        this.id_solic,
        this.estado
      )
    },
    async traerPorFiltrosConvenios() {
      this.busqueda = 'convenios'
      this.lista = await API.Autorizaciones.traerPorFiltrosConvenios(
        this.convenio,
        this.fechaconvenio
      )
    },
    guardado() {
      this.selected = undefined
      if (this.busqueda == 'ultimas') {
        this.traerlistaultimas()
      } else if (this.busqueda == 'filtros') {
        this.traerPorFiltros()
      } else {
        this.traerPorFiltrosConvenios()
      }

    },
  },
  watch: {
    nuevo() {
      this.id_afiliado = this.nuevo.id_afiliado
    }
  },
  mounted() {
    this.traerlistaultimas()
  },
}
</script>

<style></style>
